<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import BorcDetayModal from '../customer/modals/payment_history';

export default {
  page: {
    title: "Müşteri Bakiye Farkı Listesi",
    meta: [
      { 
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BorcDetayModal
  },
  data() {
    return {  
        details:[],
        search: true,
        title: "MÜŞTERİ BAKİYE FARKI LİSTESİ",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ BAKİYE FARKI LİSTESİ",
          active: true,
        },
      ],
      isLoading: false,
      detailSearch:true,
      total:0,
      form:{ tur:'' },
      list: {},
      ilList:[],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
        url: "/reports/borclu-musteriler",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      openRightDrawer: false,
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
     columns: [   
        {
          label: '#',
          field: '#',
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
        },
        {
          label: 'İsim Soyisim',
          field: this.fullname,
          sortable: false,
        },
        {
          label: 'Telefon',
          field: 'phonenumber',
          sortable: false,
        },
        {
          label: 'Whatsapp',
          field: 'phonenumber2',
          sortable: false,
        },        
        {
          label: 'Bakiye',
          field: 'balance',
        }
      ],
    };
  },
  mounted() {
    this.loadItems()
    this.ilListesi()
  },
  methods: {
    fullname(obj){
        return obj.fname + ' ' + obj.lname
    },
     async ilListesi(){
        const response = await this.$http.post(`/address/il/0`)
        this.ilList = response.data;
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        this.info = response.info
        this.total = response.total
    })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.content.data,
              info: res.data.content.info,
              totalRecords: res.data.content.total,
              pageLength: res.data.content.last_page,
              currentPage: res.data.content.current_page,
              total: res.data.total,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
    detay(props){
       this.list = props
       this.$parent.$bvModal.show('payment_history_modal')
    },
    async excelExport() {
        const currentDate = new Date();

        const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_Musteri_Fark_Listesi.xlsx`;

        this.$http.post('/reports/borclu-musteriler?excel=true', this.serverParams, { responseType: 'blob' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.error('Excel dosyası indirilirken bir hata oluştu:', error);
        });
        
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <BorcDetayModal :data="list" />
        <div class="row mb-3">
        <div class="col-md-6 offset-lg-6 text-end">
           <div class="button-items mx-2">
            <button 
                    class="btn btn-success" 
                    type="button"  
                    @click="excelExport">
                    Excel'e Al
             </button>

             <button 
                class="btn btn-outline-light bg-light" 
                :class="{ activeClass: detailSearch }"
                type="button"  
                @click="detailSearch = !detailSearch">
                <i class="bx bx-filter-alt"></i> Detaylı Arama
            </button>
          </div>
      </div>
     <Transition  name="fade" v-if="detailSearch">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  <div class="col-xl-4">
                     <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="d-flex justify-content-between">Borc Tarih Aralığı
                            <span 
                                v-if="form.startdate || form.startdateend" 
                                class="text-danger" 
                                @click="form.startdate= '' ;form.startdateend= ''">
                              </span>
                            </label>
                            <div class="input-group">
                            <input type="date" class="form-control" v-model="form['startdate']">
                            <button style="border:0;background: transparent;">  - </button>
                            <input type="date" class="form-control" v-model="form['startdateend']">
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="mb-3">
                      <label>Tür</label>
                      <select v-model="form.tur" class="form-select">
                        <option value="">Hepsi</option>
                        <option value="b">Borçlu</option>
                        <option value="a">Alacaklı</option>
                      </select>
                    </div>
                  </div>
                   <div class="col-xl-3">
                    <div class="mb-3">
                      <label>İlçe</label>
                      <select v-model="form.ilce" class="form-select">
                        <option v-for="(iller,i) in ilList" :value="iller.id" :key="i">{{ iller.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <label>-</label>
                        <div class="button-items">
                            <button 
                              type="submit"
                              class="btn btn-primary w-100 "   
                              >
                              Sorgula
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
        <div class="col-12">
            <vue-good-table
                mode="remote"
                :line-numbers="true"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div class="px-3" slot="table-actions">
                   Toplam Alacak:{{ total }}
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <b-dropdown
                    v-if="props.column.field === '#'"
                    class="ms-2 "
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    right
                >
                    <template #button-content>
                      <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                    <template>
                        <b-dropdown-item @click="detay(props.row)">Ödeme Geçmişi</b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
            </vue-good-table>
        </div>
    </div>
  </Layout>
</template>